import { useEffect, useState } from 'react';
import { message } from 'antd';

const useMetaMask = (ontId: string) => {
  const [provider, setProvider] = useState<any>(null);

  useEffect(() => {
    // @ts-ignore
    setProvider(window.ethereum || null);
  }, []);
  return {
    getAddress: async (t: (str: string) => string) => {
      if (!provider) {
        message.warn(t('metamask_first'));
        throw new Error('no metamask provider');
      }
      const result = await provider.request({ method: 'eth_requestAccounts' });
      if (result && result.length > 1) {
        message.warn('no multi address support');
      }
      return result[0] || '';
    },
    getSignature: (ont: string, address: string) => provider.request({
      method: 'personal_sign',
      // @ts-ignore
      params: [ont, address],
    }),
    getPublicKey: (address: string) => provider.request({
      method: 'eth_getEncryptionPublicKey',
      params: [address],
    }),
  };
};

export default useMetaMask;
